import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: '10px 20px',
    cursor: 'pointer',
    borderRadius: 2,
    maxHeight: 50,
  },
  unselected: {
    backgroundColor: theme.palette.neutralLighter,
    transition: 'all 0.2s ease',
    ':hover': {
      backgroundColor: theme.palette.neutralLight,
      transform: 'scale(1.05)',
    },
  },

  selected: {
    color: theme.palette.white,
    backgroundColor: theme.palette.themePrimary,
    transition: 'all 0.2s ease',
    ':hover': {
      backgroundColor: theme.palette.themeDark,
      transform: 'scale(1.02)',
    },
  },

  scrollContainer: {
    padding: '10px 0px',

    /* Custom Scrollbar */
    '&::-webkit-scrollbar': {
      height: '5px', // Slim scrollbar
    },
    '&::-webkit-scrollbar-track': {
      background: theme.palette.neutralLighterAlt, // Track color
      borderRadius: '10px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: theme.palette.neutralQuaternaryAlt, // Scrollbar color
      borderRadius: '10px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: theme.palette.neutralQuaternary, // Darker on hover
    },
  },
}));
